import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { SIZES_WITH_RESPONSIVE_OPTION } from './types';

export default function Stack({
    children,
    space = 'md',
    hasListRole,
    className,
    ...rest
}) {
    const classes = {};

    if (Array.isArray(space)) {
        space.forEach((item, index) => {
            classes[`bp-${index}-${item}`] = true;
            classes[`bp-${index}`] = true;
        });
    }
    else {
        classes[`${space}`] = true;
    }

    return (
        <div
            data-component={`Stack`}
            role={hasListRole ? "list" : null}
            className={cx("sarsa-stack", classes, className)}
            {...rest} >
            {hasListRole
                ? React.Children.map(children, (child) => (
                    React.cloneElement(child, {
                        role: "listitem"
                    })
                ))
                : children
            }
        </div>
    );
}

Stack.propTypes = {
    /** Contents */
    children: PropTypes.node,

    /** OneOf(['none', 'gutter', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'])
     * or array of sizes (one per mobile, tablet and desktop breakpoints)
     */
    space: SIZES_WITH_RESPONSIVE_OPTION,

    /** If true, children will be rendered with a list role. The visual appearance does not change */
    hasListRole: PropTypes.bool,

    /** Additional class added to the outer container */
    className: PropTypes.string
};
